// Mock workspace profile data
export const mockProfileData = {
  workspace_id: 'workspace_tradingbase',
  workspace_name: 'tradingbase',
  site_url: 'https://tradingbase.ai',
  owner: {
    id: 'user_1',
    email: 'owner@tradingbase.com',
    name: 'John Doe',
    role: 'Workspace Owner'
  },
  plan: 'professional',
  team_members: 5,
  seat_limit: 8,
  created_at: '2024-01-15T00:00:00Z',
  renewal_date: '2026-08-15T00:00:00Z',
  billing_email: 'finance@tradingbase.com',
  timezone: 'Asia/Hong_Kong',
  locale: 'en-US',
  notifications: {
    weekly_digest: true,
    product_updates: false
  },
  api_quota: {
    daily_limit: 10000,
    used_today: 3450
  }
};
